import { GridViewWebComponent } from '../../../grid/gridView';
import { GzTitleWebComponent } from '../../../ui/gzTitle';
import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { API_TYPE_COMPANIES_FOR_TELEMETRY_EXCLUSIONS, WEB_COMPONENT_GRID_VIEW } from '../../../webcomponents.constants';
import { MdrSecurityTelemetryExclusionsWebComponentSchema, PREDEFINED_FILTERS_KEYS } from '../types';
import { defaultPageSizeOptions } from '../../../grid/gridView/types';
import { MdrSecurityTelemetryExclusionsGridViewDataProvider } from '../dataProvider/MdrSecurityTelemetryExclusionsGridViewDataProvider';
import { ColumnKeys } from '../types';
import { GetItemsResponse } from '../../../ui/gzSingleSelectComplex/types';
import { CompanyFilterDashboardAsmDataProvider } from '../../../ui/gzSingleSelectComplex/dataProvider/company/CompanyFilterDashboardAsmDataProvider';
import { FilterChangeEvents } from '../../../grid/gridFilters/types';
import { TemplateState } from '../../../types/common/types';
import { GridFilterUiConfiguration } from '../../../types/filters/types';

export class MdrSecurityTelemetryExclusionsGridView extends BaseWebComponentView {
  dom: {
    $wrapper: HTMLElement;
    $title: GzTitleWebComponent;

    $gridWrapper: HTMLElement;
    $gridView: GridViewWebComponent<any, any>;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $title: this.shadow.querySelector('#page-title'),

      $gridWrapper: this.shadow.querySelector('.grid-wrapper'),
      $gridView: this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW),
    };

    this.setLoadingState();
    this.getTranslations();
    this.setTranslatedStrings();
  }

  buildSuccessView(data: MdrSecurityTelemetryExclusionsWebComponentSchema) {
    this.showGridItems(data);

    this.removeLoadingState();
  }

  buildErrorView(error: Error): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }

  getTranslations() {
    this.translations = this.stringsTranslator.getMdrSecurityTelemetryExclusionsStrings();
  }

  setTranslatedStrings() {
    this.dom.$title.innerText = this.translations.title;
  }

  private showGridItems(data: MdrSecurityTelemetryExclusionsWebComponentSchema) {
    this.dom.$gridView.injectDependencies(this.dependencies);
    this.dom.$gridView.start().then().catch(console.error);

    this.dom.$gridView.sideMenuParent = this.shadow;

    this.dom.$gridView.propertiesSet = false;

    this.dom.$gridView.viewId = data.view.id;
    this.dom.$gridView.dataProvider = new MdrSecurityTelemetryExclusionsGridViewDataProvider(this.dependencies);
    this.dom.$gridView.allColumnDetails = data.columns;
    this.dom.$gridView.columns = data.view.displayedColumns;
    this.dom.$gridView.filters = data.view.filters;
    this.dom.$gridView.predefinedFiltersKeys = PREDEFINED_FILTERS_KEYS;
    this.dom.$gridView.isCompactViewChecked = false;
    this.dom.$gridView.defaultViewProps = data.view;
    this.dom.$gridView.activeViewProps = data.view;
    this.dom.$gridView.activeViewInitialProps = data.view;
    this.dom.$gridView.pageSize = data.view.pageSize;
    this.dom.$gridView.hasPagination = true;
    this.dom.$gridView.pageSizeOptions = defaultPageSizeOptions;
    this.dom.$gridView.enableCSVExport = false;
    this.dom.$gridView.hasSelectableRows = false;
    this.dom.$gridView.filtersUiConfigs = this.getFiltersUiConfig();

    this.dom.$gridView.propertiesSet = true;
  }

  private getFiltersUiConfig() {
    return [this.getCompanyFilterUiConfig(ColumnKeys.COMPANY)];
  }

  private getCompanyFilterUiConfig(columnKey: ColumnKeys): GridFilterUiConfiguration {
    return {
      key: columnKey,
      config: {
        apiType: API_TYPE_COMPANIES_FOR_TELEMETRY_EXCLUSIONS,
        populateFilterCallback: (filterComponent, value) => {
          const company = value.exactMatch;
          if (company) {
            const selectedValues: GetItemsResponse = {
              items: [],
              totalItemsCount: 0,
            };
            CompanyFilterDashboardAsmDataProvider.getCompanyNameById(company).then(companyName => {
              selectedValues.items.push({
                label: companyName,
                value: company,
              });
              selectedValues.totalItemsCount = 1;
              filterComponent.setFilterOptions(selectedValues).then(() => {
                filterComponent.value = value.exactMatch;
                const event = new CustomEvent(FilterChangeEvents.REMOTE_SELECT_CHANGED, {
                  detail: {
                    selectedValue: company,
                    label: companyName,
                  },
                  bubbles: true,
                  composed: true,
                });
                filterComponent.dispatchEvent(event);
              });
            });
          }
        },
      },
    };
  }
}
